import { useEffect, useState } from "react";
import { isMobileView } from "./CommonFunctions";

const SignInLoading = ({message="Loading your profile..."}) => {
  const [loadingText, setLoadingText] = useState(message || "Loading your profile...");
  const [dots, setDots] = useState("");

  useEffect(() => {
    const textMessages = [
      "Loading your profile...",
    ];

    let messageIndex = 0;
    const textInterval = setInterval(() => {
      messageIndex = (messageIndex + 1) % textMessages.length;
      setLoadingText(textMessages[messageIndex]);
    }, 2000);

    const dotsInterval = setInterval(() => {
      setDots(prev => {
        if (prev === "...") return "";
        return prev + ".";
      });
    }, 500);

    return () => {
      clearInterval(textInterval);
      clearInterval(dotsInterval);
    };
  }, []);

  return (
    <div className="fixed z-100 inset-0 flex justify-center items-center h-screen w-full login-purple-diagonal-gradient animate-gradient-x">
      {/* Background decorative elements */}
     {!isMobileView() && <><div className="absolute w-[300px] h-[300px] rounded-full bg-white/10 top-[10%] left-[10%] animate-[float_8s_infinite_ease-in-out] z-100"></div>
      <div className="absolute w-[200px] h-[200px] rounded-full bg-white/10 bottom-[20%] right-[15%] animate-[float_8s_infinite_ease-in-out] z-100 animation-delay-[2s]"></div>
      <div className="absolute w-[150px] h-[150px] rounded-full bg-white/10 bottom-[10%] left-[20%] animate-[float_8s_infinite_ease-in-out] z-100 animation-delay-[4s]"></div></>}

      <div className="relative backdrop-blur-sm bg-white w-full max-w-md rounded-2xl shadow-2xl border border-white/20 mx-5">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-32 h-32  rounded-full -translate-x-1/2 -translate-y-1/2 blur-xl"></div>

        <div className="relative p-12 flex flex-col items-center">
          {/* Loading Animation */}
          <div className="relative mb-8">
            {/* Outer spinning ring */}
            <div className="w-20 h-20 rounded-full border-4 border-gray-200"></div>
            <div className="absolute top-0 left-0 w-20 h-20 rounded-full border-4 border-transparent border-t-indigo-500 animate-spin"></div>

            {/* Inner pulsing circle */}
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 login-purple-diagonal-gradient rounded-full animate-pulse flex items-center justify-center">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
          </div>

          {/* Loading Text */}
          <div className="text-center">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              {loadingText}
            </h2>
            <p className="text-gray-600 flex items-center justify-center">
              Please wait
              <span className="ml-1 w-8 text-left">{dots}</span>
            </p>
          </div>


        </div>
      </div>
    </div>
  );
};
export default SignInLoading;